import React from 'react';
import { Badge, Button } from 'antd';
import { PermissionHoc } from '../../HOC';

const EditPermissableButton = PermissionHoc(Button,"CONTACTS_WRITE", { is_component: true, fallbackComponent: null });

export const getContactsTableColumns = (methods) => [{
    title: "Name",
    key: "name",
    render: (record) => <span>{record.name}</span>
}, {
    title: "Email ID",
    key: "email",
    render: (record) => <span>{record.email}</span>
}, {
    title: "Phone No.",
    key: "phone",
    render: (record) => <span>{record.phone}</span>
}, {
    title: "Actions",
    render: (record) => <>
        <EditPermissableButton className="mr-1" onClick={() => methods.toggleContactModal({ ...record, is_edit: true })}>Edit</EditPermissableButton>
        {/* {!record.is_submerchant? <EditPermissableButton className="mr-1" onClick={() => methods.toggleContactModal({ ...record, is_edit: true })}>Edit</EditPermissableButton> : null } */}
        <Button style={{ marginRight: 4 }} onClick={() => methods.toggleBeneficiariesDrawer(record)}>Beneficiaries</Button>
        <Button onClick={() => methods.redirectToTransfer(record)}>View Transactions</Button>
    </>
}];

export const contactsTableFilterNodes = [{
    label: "Name",
    field: "name",
    placeholder: "Enter Name",
    inputType: "text",
    defaultValue: ""
}, {
    label: "Email ID",
    field: "email",
    placeholder: "Enter Email ID",
    inputType: "text",
    defaultValue: ""
}, {
    label: "Phone No.",
    field: "phone",
    placeholder: "Enter Phone No.",
    inputType: "text",
    defaultValue: ""
}];


// export const contactsTableFilterNodes = (current_user) => {
//     var nodes = [{
//         label: "Name",
//         field: "name",
//         placeholder: "Enter Name",
//         inputType: "text",
//         defaultValue: ""
//     }, {
//         label: "Email ID",
//         field: "email",
//         placeholder: "Enter Email ID",
//         inputType: "text",
//         defaultValue: ""
//     }, {
//         label: "Phone No.",
//         field: "phone",
//         placeholder: "Enter Phone No.",
//         inputType: "text",
//         defaultValue: ""
//     }];

//    if (current_user.is_reseller && current_user.esda){
//         nodes.unshift({
//             label: "Merchant",
//             field: "submerchant_id",
//             placeholder: "Merchant ID",
//             width: 250,
//             inputType: "select",
//             showSearch: true,
//             defaultValue: undefined,
//             options: current_user.submerchants ? current_user.submerchants.map((sub_merchant, index) => {
//                 let object = {};
//                 object.key = index;
//                 object.value = sub_merchant.id;
//                 object.label = sub_merchant.name+" ("+sub_merchant.email+")"
//                 return object;
//             }): []

//         })
//     }
//     return nodes
// }